import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SoundService {
  private platformId = inject<Object>(PLATFORM_ID);

  private ticketAudio: HTMLAudioElement | undefined;
  private messageAudio: HTMLAudioElement | undefined;
  private isBrowser: boolean;

  constructor() {
    const platformId = this.platformId;

    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.ticketAudio = new Audio('assets/sounds/ticket-sound.wav');
      this.messageAudio = new Audio('assets/sounds/answer-tone.wav');

      this.ticketAudio.load();
      this.messageAudio.load();
    }
  }

  newTicketSound() {
    if (!this.isBrowser || !this.ticketAudio) {
      return;
    }

    const clone = this.ticketAudio.cloneNode(true) as HTMLAudioElement;
    clone
      .play()
      .catch((err) =>
        console.warn(
          'User does not interact with the Page... Fail on play audio file.'
        )
      );
  }

  newMessageSound() {
    if (!this.isBrowser || !this.messageAudio) {
      return;
    }

    const clone = this.messageAudio.cloneNode(true) as HTMLAudioElement;
    clone
      .play()
      .catch((err) =>
        console.warn(
          'User does not interact with the Page... Fail on play audio file.'
        )
      );
  }
}
